import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import {
	AddUserRequestStatus,
	AddUserRequestStatusEvent,
} from 'src/app/ui/add-user/add-user-main-tab.component';
import { MatDivider } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-add-user-confirmation',
	templateUrl: './add-user-confirmation.component.html',
	styleUrls: [
		'./add-user-confirmation.component.css',
		'../../common/main.scss',
		'../../common/stepper.scss',
	],
	imports: [MatDivider, MatProgressSpinner, MatButton],
})
export class AddUserConfirmationComponent implements OnInit {
	@Input() companyId?: string;
	@Input() addUserRequestStatusEvents!: Observable<AddUserRequestStatusEvent>;
	showLoading = false;
	showSuccess = false;
	showFailure = false;

	userName = '';
	userEmail = '';
	roleName = '';
	companyName = '';

	constructor(
		private readonly router: Router,
		private readonly navHistory: NavigationHistoryService
	) {}

	ngOnInit(): void {
		this.addUserRequestStatusEvents.subscribe((event) => {
			this.showLoading = false;
			this.showSuccess = false;
			this.showFailure = false;

			this.userName = event?.data?.userName ?? '';
			this.userEmail = event?.data?.userEmail ?? '';
			this.companyName = event?.data?.companyName ?? '';
			this.roleName = event?.data?.roleName ?? '';

			switch (event.status) {
				case AddUserRequestStatus.loading:
					this.showLoading = true;
					break;
				case AddUserRequestStatus.success:
					this.showSuccess = true;
					break;
				case AddUserRequestStatus.failure:
					this.showFailure = true;
					break;
			}
		});
	}

	onAddUserClicked(): void {
		this.router.navigate(['/add-user'], {
			queryParams: { companyId: this.companyId },
		});
	}

	onUserDirectoryClicked(): void {
		this.navHistory.navigateBack();
	}
}
